export enum CONTACT_OPTIONS {
    IS_NEW = 'IS_NEW',
    CONTACT_EXISTS = 'CONTACT_EXISTS'
}